import React from 'react';
import { Page } from '../Page';
import { Zap, Heart, Brain } from 'lucide-react';
export function SupplementCoQ10() {
  return <Page pageNumber={16} variant="light" data-id="element-2376">
      <div className="flex h-full gap-10" data-id="element-2377">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2378">
          <img src="https://cdn.magicpatterns.com/uploads/t2rnxGtAEqZJZyXdw5PAnf/pasted-image.png" alt="Thorne CoQ10" className="w-full max-w-[280px] object-contain" data-id="element-2379" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2380">
          <div className="mb-6 pt-4" data-id="element-2381">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2382">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2383">
              CoQ10
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2384">
              Cellular energy + cardiovascular protection
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2385" />
          </div>

          <div className="mb-8" data-id="element-2386">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2387">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2388">
              Cellular energy production becomes critical when caloric intake
              drops. CoQ10 fuels the mitochondria that power your heart, brain,
              and muscles. It also provides antioxidant protection during the
              metabolic stress of rapid weight loss and supports cardiovascular
              health, important since many GLP-1 patients have cardiometabolic
              risk factors.
            </p>
          </div>

          <div className="mb-8" data-id="element-2389">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2390">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2391">
              <li className="flex gap-2" data-id="element-2392">
                <Heart className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2393" />
                <span data-id="element-2394">
                  Supports heart health and cardiovascular function during
                  weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2395">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2396" />
                <span data-id="element-2397">
                  Maintains cellular energy production during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2398">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2399" />
                <span data-id="element-2400">
                  Provides antioxidant support for brain function and cognitive
                  health
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2401">
                <span className="text-tealslate shrink-0" data-id="element-2402">•</span>
                <span data-id="element-2403">
                  Proprietary well-absorbed form with lycopene + turmeric, NSF
                  Certified
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2404">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2405">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2406">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2407">
                <strong data-id="element-2408">1-2 gelcaps daily</strong> with a meal containing fat
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2409">
                100mg CoQ10 per gelcap • 60 gelcaps per bottle
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2410">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2411" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2412">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}